import { defineComponent, inject } from 'vue'
import dayjs from 'dayjs'
import { useLocale, useNamespace } from '@jdesign-vue/hooks'
import { ROOT_PICKER_INJECTION_KEY } from '../constants'
import { basicCellProps } from '../props/basic-cell'

export default defineComponent({
  name: 'JdDatePickerCell',
  props: basicCellProps,
  setup(props) {
    const ns = useNamespace('date-table-cell')
    const { slots } = inject(ROOT_PICKER_INJECTION_KEY)!
    return () => {
      const { cell } = props

      const { t } = useLocale()

      if (slots.default) {
        const list = slots.default(cell).filter((item) => {
          return (
            item.patchFlag !== -2 && item.type.toString() !== 'Symbol(Comment)'
          )
        })
        if (list.length) {
          return list
        }
      }
      const formattedDate = cell?.date
        ? dayjs(cell.date).format('YYYY-MM-DD') +
          (cell?.disabled ? t('el.common.hasDisabled') : '')
        : ''

      return (
        <div
          class={ns.b()}
          aria-selected={cell?.isCurrent}
          aria-disabled={cell?.disabled}
          aria-label={formattedDate}
        >
          <span
            class={ns.e('text')}
            aria-selected={cell?.isCurrent}
            aria-disabled={cell?.disabled}
          >
            {cell?.text}
          </span>
        </div>
      )
    }
  },
})
